import { Head, Link } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import { formatDate as formatDateUtil } from "@/lib/date-utils"
import type { BreadcrumbItem } from "@/types"

interface IncompleteReport {
  id: number
  case_id: number
  report_date: string | null
  case_name: string | null
  leader_name: string | null
}

interface Props {
  reports: IncompleteReport[]
}

function formatDate(dateStr: string | null): string {
  return formatDateUtil(dateStr, {
    month: "numeric",
    day: "numeric",
    year: "numeric",
  })
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Reports", href: "#" },
  { title: "Incomplete Reports", href: "/reports/incomplete_reports" },
]

export default function IncompleteReports({ reports }: Props) {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Incomplete Reports" />

      <div className="p-6">
        <h1 className="mb-6 text-2xl font-semibold">Incomplete Reports</h1>

        {reports.length > 0 ? (
          <div className="border-hpi-light-gray rounded border bg-white">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-hpi-light-gray border-b bg-gray-50">
                  <th className="px-4 py-3 text-left font-medium">Date</th>
                  <th className="px-4 py-3 text-left font-medium">Case</th>
                  <th className="hidden px-4 py-3 text-left font-medium md:table-cell">
                    Leader
                  </th>
                </tr>
              </thead>
              <tbody>
                {reports.map((report) => (
                  <tr
                    key={report.id}
                    className="border-hpi-light-gray border-b last:border-0"
                  >
                    <td className="px-4 py-3">
                      <Link
                        href={`/cases/${report.case_id}/reports/${report.id}`}
                        className="text-hpi-active-blue"
                      >
                        {formatDate(report.report_date)}
                      </Link>
                    </td>
                    <td className="px-4 py-3">
                      <Link
                        href={`/cases/${report.case_id}`}
                        className="text-hpi-active-blue"
                      >
                        {report.case_name}
                      </Link>
                    </td>
                    <td className="hidden px-4 py-3 md:table-cell">
                      <Link
                        href={`/cases/${report.case_id}/reports/${report.id}`}
                        className="text-hpi-active-blue"
                      >
                        {report.leader_name}
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="rounded border border-green-300 bg-green-50 p-4 text-center text-green-700">
            No Incomplete Reports found
          </div>
        )}
      </div>
    </AppLayout>
  )
}
